import SubscriptionAppConfig from './subscription-app/SubscriptionAppConfig';
import DevicesAppConfig from './devices-app/DevicesAppConfig';
import CompanyAppConfig from './company-app/CompanyAppConfig';
import AlarmsAppConfig from './alarms-app/AlarmsAppConfig';

const appsConfigs = [SubscriptionAppConfig, DevicesAppConfig, CompanyAppConfig, AlarmsAppConfig];

export default appsConfigs;
